import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

import StorySlide from './components/StorySlide.svelte';

let storiesContainer = findElementByIdInShadowDom('women-killed-stories');

renderSvelteComponent(StorySlide, /** @type {HTMLElement} */ storiesContainer);
